// extracted by mini-css-extract-plugin
export default {"errorMessage":"DiscourseSSO_errorMessage__5ew0i"};